<template>
  <SoAlert
    v-if="tariffQuoter.isElectricitySelected || tariffQuoter.isGasSelected"
    title="Estimation Breakdown"
    type="info"
  >
    <div class="font-weight-medium mt-2">By Fuel</div>
    <SoDivider />
    <div class="estimate__layout-grid my-2">
      <template v-if="tariffQuoter.isElectricitySelected">
        <template v-if="tariffQuoter.fuelEstimation.electricityDay">
          <div class="d-flex align-center">
            <SoIcon icon="weather-sunny" size="small" class="pb-1 pr-1" />
            Electricity Day
          </div>
          <div>{{ tariffQuoter.fuelEstimation.electricityDay }} kWh</div>
          <div class="d-flex align-center">
            <SoIcon icon="weather-night" size="small" class="pb-1 pr-1" />
            Electricity Night
          </div>
          <div>{{ tariffQuoter.fuelEstimation.electricityNight }} kWh</div>
        </template>
        <template v-else>
          <div class="d-flex align-center">
            <SoIcon icon="electric" size="small" class="pb-1 pr-1" />
            Electricity
          </div>
          <div>{{ tariffQuoter.fuelEstimation.electricity }} kWh</div>
        </template>
      </template>
      <template v-if="tariffQuoter.isGasSelected">
        <div class="d-flex align-center">
          <SoIcon icon="gas" size="small" class="pb-1 pr-1" />Gas
        </div>
        <div>{{ tariffQuoter.fuelEstimation.gas }} kWh</div>
      </template>
    </div>
    <div class="font-weight-medium">Total</div>
    <SoDivider class="mb-2" />
    <div class="estimate__layout-grid my-2">
      <div class="d-flex align-center">
        <SoIcon icon="home" size="small" class="pb-1 pr-1" />Home
      </div>
      <div>{{ tariffQuoter.totalFuelEstimation }} kWh</div>
    </div>
    <UsageEstimatorOfgemBands class="mt-4" />
  </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useTariffQuoter } from "@/stores/tariffQuoter"
  import SoAlert from "@/components/SoAlert.vue"
  import SoIcon from "@/components/SoIcon.vue"
  import SoDivider from "@/components/SoDivider.vue"
  import UsageEstimatorOfgemBands from "@/views/customer/components/UsageEstimator/UsageEstimatorOfgemBands.vue"

  export default defineComponent({
    components: {
      SoAlert,
      SoIcon,
      SoDivider,
      UsageEstimatorOfgemBands,
    },
    data() {
      return {
        tariffQuoter: useTariffQuoter(),
      }
    },
  })
</script>

<style scoped>
  .estimate__layout-grid {
    display: grid;
    align-items: center;
    grid-template-columns: 8fr 12fr;
    gap: 8px;
  }
</style>
